import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Box,
  Input,
  Text,
  Icon,
  Tag,
  Skeleton,
  Badge,
  Spinner,
} from "@nimbus-ds/components";
import { Page } from "@nimbus-ds/patterns";
import {
  CheckIcon,
  SearchIcon,
  // UndoIcon,
  GlobeIcon,
  ArrowLeftIcon,
  RedoIcon,
  TiendanubeIcon,
  // CheckCircleIcon,
  ChevronUpIcon,
  ChevronDownIcon,
  AppsIcon,
  // ExclamationTriangleIcon,
} from "@nimbus-ds/icons";

import { DataTable } from "@nimbus-ds/patterns";
import { IconButton, Select, Thumbnail, Toggle } from "@nimbus-ds/components";
// import {
//   // CheckCircleIcon,
//   ChevronUpIcon,
//   ChevronDownIcon,
//   // ExclamationTriangleIcon,
// } from "@nimbus-ds/icons";
import "@nimbus-ds/styles/dist/index.css";
import CustomModal from "./CustomModal";
import CustomTooltip from "./CustomTooltip";
import { ProductService, SizeGuideService } from "Services";
import { RsProductProps, CommonBaseProps } from "./types.d";
import LanguageSelector from "./LanguageSelector";
import { FormattedMessage, useIntl } from "react-intl";

const pageSize = 20;

interface CustomTableProps {
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  searchQuery: string;
  onUnclassifiedCountChange: (count: number) => void;
  onTotalItemsCountChange: (count: number) => void;
  storeInfo: any;
}

// interface CommonBaseProps {
//   Id: number;
//   Name: string;
// }

// // const products = [
// //   {
// //     id: 1,
// //     productName: "Sweater",
// //     guideNumber: "AB3CD8FG2H",
// //     fit: "holgado",
// //     status: true,
// //     sizes: ["S", "M", "L", "XL"],
// //     estado: true,
// //   },
// // ];

// interface RsProductProps {
//   CompanyId: number;
//   PlatformProductId: number;
//   PlatformCode: string;
//   ImageUrl: string;
//   Name: string;
//   SizeGuide: CommonBaseProps;
//   Sizes: string[];
//   FitType: CommonBaseProps;
//   Status: CommonBaseProps;
//   Classified: boolean;
//   Modified: boolean | null;
// }

// interface RowProps {
//   id: number;
//   productName: string;
//   guideNumber: string;
//   fit: string;
//   status: boolean;
//   sizes: string[];
//   estado: boolean;
// }

const CustomTableHeader: React.FC<CustomTableProps> = ({
  onSearchChange,
  onUnclassifiedCountChange,
  onTotalItemsCountChange,
  storeInfo,
}) => {
  const [rsProducts, setRsProducts] = useState<RsProductProps[]>([]);
  const [rsFitsProducts, setRsFitsProducts] = useState<CommonBaseProps[]>();
  const [rsSizeGuides, setRsSizeGuides] = useState<CommonBaseProps[]>();
  const [showSpinner, setShowSpinner] = useState<boolean>(false);

  const [modifiedCount, setModifiedCount] = useState<number>(0);
  const [unclassifiedCount, setUnclassifiedCount] = useState<number>(0);
  const [disabledCount, setDisabledCount] = useState<number>(0);
  const [rows, setRows] = useState<RsProductProps[]>([]);
  const [checkedRows, setCheckedRows] = useState<number[]>([]);
  const [headerCheckboxStatus, setHeaderCheckboxStatus] = useState(false);
  const [headerIndeterminateStatus, setHeaderIndeterminateStatus] =
    useState(false);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [sortDirection, setSortDirection] = useState<
    "ascending" | "descending"
  >("descending");
  const [sortColumn, setSortColumn] = useState<
    "id" | "clientName" | "condicion"
  >("id"); // Update sortColumn state
  const [condicionSortOrder, setCondicionSortOrder] = useState<
    "clasificados" | "noClasificados"
  >("clasificados");
  const [totalItemsCount, setTotalItemsCount] = useState<number>(0);
  const [noClasificadosClicked, setNoClasificadosClicked] = useState(false);
  const [desactivadosClicked, setDesactivadosClicked] = useState(false);
  const [searchQuery, setSearchQuery] = useState<string>("");

  const navigate = useNavigate();
  const intl = useIntl();

  const GetProductsList = async () => {
    try {
      setShowSpinner(true);

      const response = await ProductService.GetProductsList(storeInfo.id);

      // console.log("Fetched products:", response.Content);

      setShowSpinner(false);

      if (response && response.Status === 200) {
        return response.Content || [];
      } else {
        return [];
      }
    } catch (error) {
      console.log("ERROR GetProductsList", error);

      setShowSpinner(false);
    }
  };

  const GetSyncProductsList = async () => {
    try {
      setShowSpinner(true);

      const response = await ProductService.GetProductsSyncPlatform(
        storeInfo.id
      );

      setShowSpinner(false);

      if (response && response.Status === 200) {
        return response.Content || false;
      }
    } catch (error) {
      console.log("ERROR GetSyncProductsList", error);

      setShowSpinner(false);
    }

    return false;
  };

  const GetSyncProduct = async (platformCode: string) => {
    try {
      setShowSpinner(true);

      const response = await ProductService.GetProductSyncPlatform(
        storeInfo.id,
        platformCode
      );

      setShowSpinner(false);

      if (response && response.Status === 200) {
        return response.Content;
      } else {
        return null;
      }
    } catch (error) {
      console.log("ERROR GetSyncProduct", error);

      setShowSpinner(false);
    }

    return null;
  };

  const GetProductsFits = async () => {
    try {
      setShowSpinner(true);

      const response = await ProductService.GetProductsFits(storeInfo.id);

      setShowSpinner(false);

      if (response && response.Status === 200) {
        return response.Content || [];
      } else {
        return [];
      }
    } catch (error) {
      console.log("ERROR GetProductsFits", error);

      setShowSpinner(false);
    }
  };

  const GetSizeGuides = async () => {
    try {
      setShowSpinner(true);

      const response = await SizeGuideService.GetSizeGuidesList(storeInfo.id);

      setShowSpinner(false);

      if (response && response.Status === 200) {
        return response.Content || [];
      } else {
        return [];
      }
    } catch (error) {
      console.log("ERROR GetSizeGuides", error);

      setShowSpinner(false);
    }
  };

  const PostProductsList = async (products: RsProductProps[]) => {
    try {
      const response = await ProductService.PostSaveChange(
        storeInfo.id,
        products
      );

      if (response && response.Status === 200) {
        // if (response.Content) setRsProducts(response.Content);

        return response.Content;
      } else {
        return false;
      }
    } catch (error) {
      console.log("ERROR PostProductsList", error);
      setShowSpinner(false);
    }
  };

  /* Useeffect para filtrar por botones */

  const ApplyFilters = ({
    products = null,
    onSearchQuery = null,
    notClassified = null,
    onlyDesactivate = null,
  }: {
    products?: any[] | null;
    onSearchQuery?: string | null;
    notClassified?: boolean | null;
    onlyDesactivate?: boolean | null;
  }) => {
    try {
      let filteredRows: RsProductProps[];

      if (products) {
        filteredRows = products;

        setSearchQuery("");
        setDesactivadosClicked(false);
        setNoClasificadosClicked(false);
      } else {
        filteredRows = [...rsProducts];
      }

      const modifiedProducts = filteredRows.filter(
        (row) => row.Modified
      ).length;

      if (onSearchQuery) {
        filteredRows = filteredRows.filter((row) =>
          row.Name.toLowerCase().includes(onSearchQuery.toLowerCase())
        );
      }

      if (notClassified) {
        filteredRows = filteredRows.filter((row) => !row.Classified);
      }

      if (onlyDesactivate) {
        filteredRows = filteredRows.filter((row) => row.Status.Id !== 1);
      }

      const unclassifiedCount = filteredRows.filter(
        (row) => !row.Classified
      ).length;
      const disabledCount = filteredRows.filter(
        (row) => row.Status.Id !== 1
      ).length;

      setRows(filteredRows);
      setUnclassifiedCount(unclassifiedCount);
      setDisabledCount(disabledCount);
      setModifiedCount(modifiedProducts);
      setTotalItemsCount(filteredRows.length);
    } catch (error) {
      console.log("ERROR ApplyFilters", error);
    }
  };

  useEffect(() => {
    GetProductsFits().then(setRsFitsProducts);
    GetSizeGuides().then(setRsSizeGuides);

    GetProductsList().then((data) => {
      if (!data.length) {
        GetSyncProductsList().then((state) => {
          if (state) {
            GetProductsList().then((dataSync) => {
              setRsProducts(dataSync);
              // setRows(dataSync);
              ApplyFilters({ products: dataSync });
            });
          }
        });
      } else {
        setRsProducts(data);
        // setRows(data);
        ApplyFilters({ products: data });
      }
    });
  }, []);

  const onClickCargar = async () => {
    try {
      GetSizeGuides().then(setRsSizeGuides);

      const data = await GetProductsList();

      if (data) {
        setRsProducts(data);
        // setRows(data);
      } else {
        setRsProducts([]);
      }

      ApplyFilters({ products: data });
    } catch (error) {
      console.log(`Error onClickCargar`, error);
    }
  };

  const onClickActualizarGuias = async () => {
    try {
      GetSizeGuides().then(setRsSizeGuides);
    } catch (error) {
      console.log(`Error onClickActualizarGuias`, error);
    }
  };

  const onClickSincronizar = async () => {
    try {
      const stateSincronizar = await GetSyncProductsList();

      if (stateSincronizar) {
        const data = await GetProductsList();

        setRsProducts(data);
        setRows(data);
      }
    } catch (error) {
      console.log(`Error onClickSincronizar`, error);
    }
  };

  const OnClickSincronizarProduct = async (id: number) => {
    try {
      if (id !== undefined && id !== null) {
        const productsUpdated = [...rsProducts];

        const product = productsUpdated?.find((data: RsProductProps) => {
          return data.PlatformProductId === id;
        });

        if (product) {
          const responseProduct = await GetSyncProduct(product.PlatformCode);

          if (responseProduct) {
            product.Name = responseProduct.Name;
            product.SizeGuide = responseProduct.SizeGuide;
            product.Sizes = responseProduct.Sizes;
            product.FitType = responseProduct.FitType;
            product.Status = responseProduct.Status;
            product.Classified = responseProduct.Classified;
            product.ImageUrl = responseProduct.ImageUrl;
            product.Modified = false;
          }
        }

        setRsProducts(productsUpdated);
        // setRows(productsUpdated);
        ApplyFilters({
          notClassified: noClasificadosClicked,
          onSearchQuery: searchQuery,
          onlyDesactivate: desactivadosClicked,
        });
      }
    } catch (error) {
      console.log("ERROR OnClickSincronizarProduct", error);
    }
  };

  const handleGuardarCambiosClick = async () => {
    try {
      const productsSave = rsProducts.filter((product: RsProductProps) => {
        return product.Modified || false;
      });

      if (productsSave) {
        setShowSpinner(true);

        const response = await PostProductsList(productsSave);

        if (response) {
          const productsUpdate = [...rsProducts];

          productsSave.forEach((saved: RsProductProps) => {
            const product = productsUpdate.find((item: RsProductProps) => {
              return item.PlatformProductId === saved.PlatformProductId;
            });

            if (product) {
              product.Modified = false;
            }
          });

          setRsProducts(productsUpdate);
          ApplyFilters({
            notClassified: noClasificadosClicked,
            onSearchQuery: searchQuery,
            onlyDesactivate: desactivadosClicked,
          });
        }

        setShowSpinner(false);
      }
    } catch (error) {
      console.log("ERROR handleGuardarCambiosClick", error);

      setShowSpinner(false);
    }
    // const updatedRows = rows.map((row) => {
    //   if (checkedRows.includes(row.PlatformProductId)) {
    //     return row.Status.Id === 1
    //       ? row
    //       : { ...row, Status: { Id: 1, Name: "Active" } };
    //   }
    //   return row;
    // });
    // setRows(updatedRows);
    // setCheckedRows([]);
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    ApplyFilters({
      notClassified: noClasificadosClicked,
      onSearchQuery: e.target.value,
      onlyDesactivate: desactivadosClicked,
    });
    setSearchQuery(e.target.value);
  };

  const redirectToReadySize = () => {
    window.open("https://app.readysize.ai/login", "_blank");
  };

  const handleReturnClick = () => {
    navigate("/");
  };

  const handleRowClick = (id: number) => {
    if (checkedRows.includes(id)) {
      setCheckedRows(checkedRows.filter((rowId) => rowId !== id));
    } else {
      setCheckedRows([...checkedRows, id]);
    }
  };

  const handleModalConfirm = (
    selectedSizeGuideId: any,
    selectedFitTypeId: any
  ) => {
    try {
      const productsUpdated = [...rsProducts];

      checkedRows.forEach((rowId) => {
        const product = productsUpdated?.find((data: RsProductProps) => {
          return data.PlatformProductId === rowId;
        });

        if (product) {
          if (selectedSizeGuideId != null && selectedSizeGuideId !== undefined)
            product.SizeGuide.Id = parseInt(selectedSizeGuideId);
          if (selectedFitTypeId != null && selectedFitTypeId !== undefined)
            product.FitType.Id = parseInt(selectedFitTypeId);
          if (selectedSizeGuideId != null && selectedSizeGuideId !== undefined)
            product.Classified = !product.Classified
              ? parseInt(selectedSizeGuideId) > 0
                ? true
                : false
              : product.Classified;
          product.Modified = true;
        }
      });

      setRsProducts(productsUpdated);
      ApplyFilters({
        notClassified: noClasificadosClicked,
        onSearchQuery: searchQuery,
        onlyDesactivate: desactivadosClicked,
      });
    } catch (error) {
      console.log("ERROR handleModalConfirm", error);
    }

    // const updatedRows = rows.map((row) => {
    //   if (checkedRows.includes(row.PlatformProductId)) {
    //     return {
    //       ...row,
    //       SizeGuide: {Id: parseInt(selectedSizeGuideId)},
    //       FitType: {Id: parseInt(selectedFitTypeId)},
    //       // Status: { Id: 1, Name: "Active" }, // Example update for Status
    //       Classified: (parseInt(selectedSizeGuideId) > 0 ? true : false),
    //       Modified: true,
    //     };
    //   }
    //   return row;
    // });
    // setRows(updatedRows);
  };

  /* check para seleccionar rows de la tabla */

  const handleHeaderCheckboxClick = () => {
    if (headerCheckboxStatus) {
      setCheckedRows([]);

      setHeaderIndeterminateStatus(headerCheckboxStatus);
      setHeaderCheckboxStatus(!headerCheckboxStatus);
    } else {
      const rowIds = rows.map((row) => row.PlatformProductId);
      setCheckedRows(rowIds);

      setHeaderIndeterminateStatus(headerCheckboxStatus);
      setHeaderCheckboxStatus(!headerCheckboxStatus);
    }
  };

  const handlePageChange = (page: number): void => {
    setCurrentPage(page);
  };

  const handleSort = (column: "id" | "clientName" | "condicion") => {
    if (column === sortColumn) {
      setSortDirection(
        sortDirection === "ascending" ? "descending" : "ascending"
      );
    } else {
      setSortColumn(column);
      setSortDirection("ascending");
    }

    if (column === "condicion") {
      setCondicionSortOrder(
        condicionSortOrder === "clasificados"
          ? "noClasificados"
          : "clasificados"
      );
    }
  };

  const sortCompareFunction = (rowA: RsProductProps, rowB: RsProductProps) => {
    if (sortColumn === "id") {
      return sortDirection === "ascending"
        ? rowA.PlatformProductId - rowB.PlatformProductId
        : rowB.PlatformProductId - rowA.PlatformProductId;
    }
    if (sortColumn === "clientName") {
      return sortDirection === "ascending"
        ? rowA.Name.localeCompare(rowB.Name)
        : rowB.Name.localeCompare(rowA.Name);
    }
    if (sortColumn === "condicion") {
      if (condicionSortOrder === "clasificados") {
        if (rowA.Classified && !rowB.Classified) return -1;
        if (!rowA.Classified && rowB.Classified) return 1;
      } else {
        if (!rowA.Classified && rowB.Classified) return -1;
        if (rowA.Classified && !rowB.Classified) return 1;
      }
      return 0;
    }
    return 0;
  };

  const getDisplayedRows = (rows: RsProductProps[]): RsProductProps[] => {
    const sortedRows = rows.slice().sort(sortCompareFunction);
    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    return sortedRows.slice(startIndex, endIndex);
  };

  const tableHeader = (
    <DataTable.Header
      checkbox={{
        name: "check-all-rows",
        checked: headerCheckboxStatus,
        onChange: handleHeaderCheckboxClick,
        indeterminate: headerIndeterminateStatus,
      }}
    >
      <DataTable.Cell width="50px">
        <FormattedMessage id="col.image" defaultMessage="Imagen" />
      </DataTable.Cell>
      <DataTable.Cell width="280px">
        <FormattedMessage id="col.name" defaultMessage="Nombre" />
      </DataTable.Cell>
      <DataTable.Cell width="250px">
        <FormattedMessage id="col.sizeguide" defaultMessage="Guía talles" />
      </DataTable.Cell>
      <DataTable.Cell width="200px">
        <FormattedMessage id="col.sizes" defaultMessage="Talles" />
      </DataTable.Cell>{" "}
      {/* New column for Talles */}
      {/* Move the title here */}
      <DataTable.Cell width="140px">
        <FormattedMessage id="col.fit" defaultMessage="Calce" />
      </DataTable.Cell>
      <DataTable.Cell width="160px">
        <div className="tn-condition-container">
          <FormattedMessage id="col.status" defaultMessage="Condicion" />
          <IconButton
            source={
              sortColumn === "condicion" && sortDirection === "ascending" ? (
                <ChevronUpIcon size={10} />
              ) : (
                <ChevronDownIcon size={10} />
              )
            }
            size="1rem"
            onClick={() => {
              handleSort("condicion");
              handleCondicionSort(); // Call handleCondicionSort when sorting by "condicion"
            }}
          />
        </div>
      </DataTable.Cell>
      <DataTable.Cell width="180px">
        <FormattedMessage id="col.enabled" defaultMessage="Habilitado" />
      </DataTable.Cell>
      <DataTable.Cell width="120px"> </DataTable.Cell>
    </DataTable.Header>
  );

  /* funcion para hacer la paginacion del footer */

  const tableFooter = () => {
    const totalRows = rows.length;
    const firstRow = (currentPage - 1) * pageSize + 1;
    const lastRow = Math.min(currentPage * pageSize, totalRows);

    return (
      <DataTable.Footer
        itemCount={intl.formatMessage(
          { id: "footer.displaying" },
          { firstRow, lastRow, totalRows }
        )}
        pagination={{
          pageCount: Math.ceil(totalRows / pageSize),
          activePage: currentPage,
          onPageChange: handlePageChange,
        }}
      />
    );
  };

  const hasBulkActions = checkedRows.length > 0 && (
    <DataTable.BulkActions
      checkbox={{
        name: "check-all",
        checked: headerCheckboxStatus,
        onChange: handleHeaderCheckboxClick,
        indeterminate: headerIndeterminateStatus,
      }}
      label={`${checkedRows.length} selected`}
      action={
        <Box display="flex" gap="1">
          <CustomModal
            sizeGuides={rsSizeGuides}
            fitTypes={rsFitsProducts}
            updateRows={handleModalConfirm}
          />
        </Box>
      }
    />
  );

  /* funcion que manejaba el fitchange */

  /* FIT EVENTOS */
  const handleFitChange = (id: number, fitTypeId: any) => {
    try {
      if (fitTypeId !== undefined && fitTypeId !== null) {
        const productsUpdated = [...rsProducts];

        const product = productsUpdated?.find((data: RsProductProps) => {
          return data.PlatformProductId === id;
        });

        if (product) {
          product.FitType.Id = parseInt(fitTypeId);
          product.Modified = true;
        }

        setRsProducts(productsUpdated);
        ApplyFilters({
          notClassified: noClasificadosClicked,
          onSearchQuery: searchQuery,
          onlyDesactivate: desactivadosClicked,
        });
      }
    } catch (error) {
      console.log("ERROR handleFitChange", error);
    }
  };
  /* FIN FIT EVENTOS */

  /* SIZE GUIDE EVENTOS */
  const handleSizeGuideChange = (id: number, sizeGuideId: any) => {
    try {
      if (sizeGuideId !== undefined && sizeGuideId !== null) {
        const productsUpdated = [...rsProducts];

        const product = productsUpdated?.find((data: RsProductProps) => {
          return data.PlatformProductId === id;
        });

        if (product) {
          product.SizeGuide.Id = parseInt(sizeGuideId);
          product.Modified = true;
          product.Classified = !product.Classified
            ? parseInt(sizeGuideId) > 0
              ? true
              : false
            : product.Classified;
        }

        setRsProducts(productsUpdated);
        // setRows(productsUpdated);
        ApplyFilters({
          notClassified: noClasificadosClicked,
          onSearchQuery: searchQuery,
          onlyDesactivate: desactivadosClicked,
        });
      }
    } catch (error) {
      console.log("ERROR handleFitChange", error);
    }
  };
  /* FIN SIZE GUIDE EVENTOS */

  const handleCondicionSort = () => {
    const sortedRows = rows.slice().sort((a, b) => {
      if (a.Classified && !b.Classified)
        return sortDirection === "ascending" ? 1 : -1;
      if (!a.Classified && b.Classified)
        return sortDirection === "ascending" ? -1 : 1;
      return 0;
    });
    setRows(sortedRows);
  };

  /* STATUS EVENTOS */
  const getStatusAppearance = (
    id: number
  ): "success" | "warning" | undefined => {
    const product = rsProducts?.find((data: RsProductProps) => {
      return data.PlatformProductId === id;
    });

    const toggleState = product && product.Status.Id === 1;
    return toggleState ? "success" : "warning";
  };

  const getStatusContent = (id: any) => {
    const product = rsProducts?.find((data) => data.PlatformProductId === id);
    return (
      <FormattedMessage
        id={
          product && product.Status.Id === 1
            ? "status.enabled"
            : "status.disabled"
        }
        defaultMessage={
          product && product.Status.Id === 1 ? "Enabled" : "Disabled"
        }
      />
    );
  };

  // const getStatusContent = (id: number) => {
  //   const product = rsProducts?.find((data: RsProductProps) => {
  //     return data.PlatformProductId === id;
  //   });

  //   const toggleState = product && product.Status.Id === 1;

  //   return (
  //     <>
  //       {toggleState ? "Habilitado" : "Deshabilitado"}
  //       {/* {toggleState ? <CheckCircleIcon /> : <ExclamationTriangleIcon />} */}
  //     </>
  //   );
  // };

  const handleToggleStatusChange = (id: number) => {
    try {
      const productsUpdated = [...rsProducts];

      const product = productsUpdated?.find((data: RsProductProps) => {
        return data.PlatformProductId === id;
      });

      if (product) {
        product.Status.Id = product.Status.Id === 1 ? 2 : 1;
        product.Modified = true;
      }

      setRsProducts(productsUpdated);
      ApplyFilters({
        notClassified: noClasificadosClicked,
        onSearchQuery: searchQuery,
        onlyDesactivate: desactivadosClicked,
      });
    } catch (error) {
      console.log("ERROR handleToggleStatusChange", error);
    }

    // setToggleStates((prevState) => ({
    //   ...prevState,
    //   [id]: !prevState[id],
    // }));
  };

  /* FIN STATUS EVENTOS */

  const handleNoClasificadosClick = () => {
    ApplyFilters({
      notClassified: !noClasificadosClicked,
      onSearchQuery: searchQuery,
      onlyDesactivate: desactivadosClicked,
    });
    setNoClasificadosClicked(!noClasificadosClicked);
  };

  const handleDesactivadosClick = () => {
    ApplyFilters({
      notClassified: noClasificadosClicked,
      onSearchQuery: searchQuery,
      onlyDesactivate: !desactivadosClicked,
    });
    setDesactivadosClicked(!desactivadosClicked);
  };

  return (
    <Page maxWidth="1920px">
      <Page.Header
        buttonStack={
          <>
            <Button onClick={handleReturnClick}>
              <Icon source={<ArrowLeftIcon />} />
              <FormattedMessage id="button.return" defaultMessage="Volver" />
            </Button>
            <Button onClick={redirectToReadySize}>
              <Icon source={<GlobeIcon />} />
              <FormattedMessage
                id="button.goToReadySize"
                defaultMessage="Ir a ReadySize"
              />
            </Button>
            {/* <Button onClick={onClickActualizarGuias}>
              Actualizar Guias de talles
              <Icon source={<AppsIcon />} />
            </Button> */}
            <Button onClick={onClickActualizarGuias}>
              <FormattedMessage
                id="button.updateSizeGuides"
                defaultMessage="Actualizar Guias de talles"
              />
              <Icon source={<AppsIcon />} />
            </Button>
            <Button onClick={onClickSincronizar}>
              <Icon source={<TiendanubeIcon />} />
              <FormattedMessage
                id="button.synchronize"
                defaultMessage="Sincronizar"
              />
            </Button>
            <Button onClick={onClickCargar}>
              <Icon source={<RedoIcon />} />
              <FormattedMessage id="button.load" defaultMessage="Cargar" />
            </Button>
            <Button appearance="primary" onClick={handleGuardarCambiosClick}>
              <Icon color="neutral-background" source={<CheckIcon />} />
              <FormattedMessage
                id="button.saveChanges"
                defaultMessage="Guardar Cambios"
              />
              {modifiedCount > 0 && (
                <Badge count={modifiedCount} theme="light" />
              )}
            </Button>
            <LanguageSelector />
          </>
        }
        title={intl.formatMessage({
          id: "page.title",
          defaultMessage: "Productos",
        })}
      >
        <Box display="flex" flexDirection="column" gap="2">
          <Box display="flex" gap="1">
            <Input.Search
              placeholder={intl.formatMessage({
                id: "search.placeholder",
                defaultMessage: "Search",
              })}
              onChange={handleSearchChange}
            />
            <Button>
              <Icon color="currentColor" source={<SearchIcon />} />
            </Button>
          </Box>
          <Box alignItems="center" display="flex" gap="2">
            {totalItemsCount > 0 && searchQuery ? (
              <>
                <Text>{totalItemsCount} productos encontrados</Text>{" "}
              </>
            ) : (
              <></>
            )}
            {/* Modified to use state */}
            {/* <Chip removable text="Filtro aplicado" /> */}
          </Box>
        </Box>{" "}
      </Page.Header>
      <Page.Body>
        {/* Include your CustomTable component here */}
        <div className="customtable-container">
          {/* <button onClick={handleUpdateStatusClick}>Update</button>{" "} */}
          <div className="customtable-custombadge-container">
            {/* Botones filtro !Classified y Status === 0 */}
            <div className="customtable-custombadge-buttons-container">
              <Button
                appearance={noClasificadosClicked ? "primary" : "neutral"}
                onClick={handleNoClasificadosClick}
              >
                <FormattedMessage
                  id="button.unclassified"
                  defaultMessage="Unclassified"
                />
                {/* No Clasificados */}
                {unclassifiedCount > 0 && (
                  <Badge appearance="danger" count={unclassifiedCount} />
                )}
              </Button>
              <Button
                appearance={desactivadosClicked ? "primary" : "neutral"}
                onClick={handleDesactivadosClick}
              >
                <FormattedMessage
                  id="button.deactivated"
                  defaultMessage="Deactivated"
                />
                {/* Desactivados */}
                {disabledCount > 0 && (
                  <Badge count={disabledCount} appearance="danger" />
                )}
              </Button>
              <CustomTooltip storeInfo={storeInfo} />
              {showSpinner && (
                <div>
                  <Spinner size="medium" />
                </div>
              )}
            </div>
          </div>
          <DataTable
            header={!headerCheckboxStatus && tableHeader}
            footer={tableFooter()}
            bulkActions={hasBulkActions}
          >
            {getDisplayedRows(rows).map((row) => {
              const { PlatformProductId, Classified } = row; // Destructure PlatformProductId and Status
              // const statusIcon = Classified ? (
              //   <CheckCircleIcon />
              // ) : (
              //   <ExclamationTriangleIcon />
              // );
              const statusAppearance = Classified ? "success" : "warning";
              const statusMsg = Classified ? "Clasificado" : "Sin Clasificar";

              return (
                <DataTable.Row
                  key={PlatformProductId}
                  backgroundColor={
                    checkedRows.includes(PlatformProductId)
                      ? {
                          rest: "primary-surface",
                          hover: "primary-surfaceHighlight",
                        }
                      : {
                          rest: "neutral-background",
                          hover: "neutral-surface",
                        }
                  }
                  checkbox={{
                    name: `check-${PlatformProductId}`,
                    checked: checkedRows.includes(PlatformProductId),
                    onChange: () => handleRowClick(PlatformProductId),
                  }}
                >
                  <DataTable.Cell className="product-image-cell-container">
                    <div className="product-image-container">
                      <Thumbnail
                        alt="Nombre del producto"
                        aspectRatio="1/1"
                        width="64px"
                        src={row.ImageUrl}
                      />
                    </div>
                  </DataTable.Cell>
                  <DataTable.Cell>{row.Name}</DataTable.Cell>{" "}
                  {/* Access Name from RsProductProps */}
                  <DataTable.Cell>
                    {rsSizeGuides === undefined || rsSizeGuides === null ? (
                      <>
                        <Skeleton
                          height="1.8rem"
                          width="9rem"
                          borderRadius="2"
                        />
                      </>
                    ) : (
                      <>
                        <Select
                          appearance="neutral"
                          id={`guideNumber-select-${PlatformProductId}`}
                          name={`guideNumber-select-${PlatformProductId}`}
                          value={row.SizeGuide.Id}
                          onChange={(e) =>
                            handleSizeGuideChange(
                              PlatformProductId,
                              e.target.value
                            )
                          }
                        >
                          {/* Render your options based on RsProductProps */}
                          <Select.Option label=".." value="0" />
                          {rsSizeGuides.map((sizeguide) => (
                            <Select.Option
                              key={sizeguide.Id}
                              label={sizeguide.Name}
                              value={`${sizeguide.Id}`}
                            />
                          ))}
                        </Select>
                      </>
                    )}
                  </DataTable.Cell>
                  <DataTable.Cell>{row.Sizes?.join(", ")}</DataTable.Cell>{" "}
                  {/* Join Sizes array */}
                  <DataTable.Cell>
                    {!rsFitsProducts ? (
                      <>
                        <Skeleton
                          height="1.8rem"
                          width="9rem"
                          borderRadius="2"
                        />
                      </>
                    ) : (
                      <>
                        <Select
                          appearance="neutral"
                          id={`fit-select-${PlatformProductId}`}
                          name={`fit-select-${PlatformProductId}`}
                          value={row.FitType.Id} // Example: Access FitType's Name property
                          onChange={(e) =>
                            handleFitChange(PlatformProductId, e.target.value)
                          }
                        >
                          <Select.Option label=".." value="0" />
                          {rsFitsProducts.map((fit) => {
                            return (
                              <>
                                <Select.Option
                                  label={fit.Name}
                                  value={`${fit.Id}`}
                                />
                              </>
                            );
                          })}
                        </Select>
                      </>
                    )}
                  </DataTable.Cell>
                  <DataTable.Cell>
                    <Tag appearance={statusAppearance}>
                      {Classified ? (
                        <FormattedMessage
                          id="status.classified"
                          defaultMessage="Clasificado"
                        />
                      ) : (
                        <FormattedMessage
                          id="status.unclassified"
                          defaultMessage="Sin Clasificar"
                        />
                      )}
                    </Tag>
                  </DataTable.Cell>
                  <DataTable.Cell>
                    <div className="rs-estado-col">
                      {/* Adjust as per your RsProductProps structure */}
                      <Tag appearance={getStatusAppearance(PlatformProductId)}>
                        {getStatusContent(PlatformProductId)}
                      </Tag>
                      <Toggle
                        name={`toggle-${PlatformProductId}`}
                        checked={row.Status.Id === 1}
                        onChange={() =>
                          handleToggleStatusChange(PlatformProductId)
                        }
                      />
                    </div>
                  </DataTable.Cell>
                  <DataTable.Cell>
                    <Button
                      appearance="transparent"
                      title="Sinchronize"
                      onClick={() =>
                        OnClickSincronizarProduct(PlatformProductId)
                      }
                    >
                      <RedoIcon />
                    </Button>
                  </DataTable.Cell>
                </DataTable.Row>
              );
            })}
          </DataTable>
        </div>
      </Page.Body>
    </Page>
  );
};

export default CustomTableHeader;
